import { render, staticRenderFns } from "./GradeData.vue?vue&type=template&id=2a265aba&scoped=true&"
import script from "./GradeData.vue?vue&type=script&lang=js&"
export * from "./GradeData.vue?vue&type=script&lang=js&"
import style0 from "./GradeData.vue?vue&type=style&index=0&id=2a265aba&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a265aba",
  null
  
)

export default component.exports